<template>
  <div>
    <el-input placeholder="输入文件夹进行搜索" v-model="filterText" class="input-filter"> </el-input>
    <div class="setup">
      <el-button type="primary" class="green-btn" size="mini" @click="settingVisible = true">文件夹管理</el-button>
    </div>
    <!-- 报表文件 -->
    <div class="treeBox" ref="buildFloor" v-loading="loading">
      <el-tree
      class="sheet-tree"
      node-key="id"
      :data="sheetData"
      :props="defaultProps"
      :icon-class="`el-icon-folder`"
      highlight-current
      :filter-node-method="filterNode"
      :default-expanded-keys="expandedKeys"
      @node-click="handleNodeClick"
      @node-expand="handleNodeExpand"
      @node-collapse="handleNodeCollapse"
      ref="tree"
    >
      <span class="my-custom" slot-scope="{ node, data }">
        <template>
          <svg class="icon svg-icon" aria-hidden="true" v-show="!node.expanded">
            <use xlink:href="#icon-folder"></use>
          </svg>
          <svg class="icon svg-icon" aria-hidden="true" v-show="node.expanded">
            <use xlink:href="#icon-opened_folder"></use>
          </svg>
        </template>
        <span v-if="data.folderName.length <= 10">{{ data.folderName }}</span>
        <el-tooltip :content="data.folderName" placement="top">
          <span v-if="data.folderName.length > 10">{{ data.folderName }}</span>
        </el-tooltip>
      </span>
    </el-tree>
    </div>
    <!-- 设置 -->
    <setting :visible.sync="settingVisible" :modulesConfig="modulesConfig" :leftTreeData="sheetData" :processType="processType" @complete="get_menu" v-if="settingVisible"></setting>

  </div>
</template>

<script>
import setting from "./setting";
import tooltips from "../directive/tooltips/index.js";
export default {
  components: { setting },
  props: ["modulesConfig",'processType'],
  directives: {
    tooltips,
  },
  data() {
    return {
      filterText: "",
      sheetData: [],
      defaultProps: {
        children: "children",
        label: "folderName",
      },
      loading: false,
      selectVisible: false,
      settingVisible: false,

      expandedKeys: [],
      selectedData: {},
      serchDataId: [],
      processTypeList: [],
    };
  },
  watch: {
    filterText(val) {
      this.serchDataId = [];
      if(!val) {
        this.$refs.tree.filter(false)
      }else if(val.length > 4) {
        this.$refs.tree.filter(val);
      }
    },
  },
  mounted() {
    this.closeTooltip()
    // this.getProcessTypeList();
    this.get_menu()
  },
  methods: {
    // getProcessTypeList() {
    //   this.$q.newProduct.processTypeList().then(res=>{
    //     this.processTypeList = res.data || []
    //     this.processType = res.data.length ? res.data[0].processType : ''
    //     this.get_menu();
    //   })
    // },
    get_menu(id) {
      if(!this.processType) return
      this.loading = true
      let params = {
        params: {
          searchFields: ''
        }
      };
      return this.$q.newProduct.fullWidthUploadGetSliceTree(params).then((res) => {
        this.sheetData = res.data;
        // this.addDis(this.sheetData)
        if(!id) {
          this.$emit('initRight')
        }else {
          this.$nextTick(_=>{
            this.$refs.tree.setCurrentKey(id)
          })
        }
        document.querySelectorAll('.el-tooltip__popper').forEach(function(el) {
          el.style.display = 'none';
        });
      }).finally(_=>{
        this.loading = false
      });
    },
    addDis(data) {
      var newId = this.sheetData.find(v=>v.folderName == '新').id
      data = data || []
      data.forEach((item) => {
        let data = item.children || []
        //children大于10条的父级禁用，或者层级<3的 新文件夹只禁用最上层文件夹选择
        if ((data.length > 10 || item.folderLevel < 3) && data.length && newId != item.parentId  ) {
          item["disabled"] = true;
        } else {
          item["disabled"] = false;
        }
        if (item.hasOwnProperty("children")) {
          this.addDis(item["children"]);
        }
      });
    },
    // tree数据转平级
    tree2flat(source) {
      let res = [];
      const fn = (source) => {
        source.forEach((el) => {
          res.push(el);
          el.children && el.children.length > 0 ? fn(el.children) : "";
        });
      };
      fn(source);
      return res;
    },
    // 节点点击
    handleNodeClick(data, node) {
      // 获取文件夹完整路径
      const folderPath = this.getNodePath(node);
      this.$emit("menu-click", data, folderPath);
    },
    // 获取节点的完整路径
    getNodePath(node) {
      const pathParts = [];
      let currentNode = node;
      while (currentNode && currentNode.data && currentNode.data.folderName) {
        pathParts.unshift(currentNode.data.folderName);
        currentNode = currentNode.parent;
      }
      return pathParts.join('/');
    },
    // 节点展开
    handleNodeExpand(data, node, $el) {
      this.expandedKeys.push(data.id);
    },
    // 节点折叠
    handleNodeCollapse(data, node, $el) {
      this.expandedKeys = this.expandedKeys.filter((v) => v != data.id);
      //当多层文件时折叠最多层级需过滤该层级下所有子层级key
      if (data.children && data.children.length) {
        let childrenDataId = this.tree2flat(data.children).map((v) => v.id);
        this.expandedKeys = this.expandedKeys.filter((v) => !childrenDataId.includes(v));
      }
    },
    //过滤保留子节点
    filterNode(value,data,node) {
      if(!value){
        node.expanded = false;
        return true;
      }
      // 需求要求取消搜索带出子集数据
      // let _array = [];
      // this.getReturnNode(node,_array,value);
      // let result = false;
      // _array.forEach((item)=>{
      //   result = result || item;
      // });
      // return result;
      return node.data &&  node.data.folderName && node.data.folderName.indexOf(value) !== -1;
    },
    getReturnNode(node,_array,value){
      let isPass = node.data &&  node.data.folderName && node.data.folderName.indexOf(value) !== -1;
      isPass?_array.push(isPass):'';
      this.index++;
      if(!isPass && node.level!=1 && node.parent){
        this.getReturnNode(node.parent,_array,value);
      }
    }, 
    expandNodeById(id) {
      // 假设我们想要展开 id 为 4 的节点
      const nodeId = id;
      const tree = this.$refs.tree;
      const node = tree.getNode(nodeId);
      if (node) {
        this.expandParentNodes(node);
      }
    },
    expandParentNodes(node) {
      if (node.parent) {
        node.parent.expanded = true;
        this.expandParentNodes(node.parent);
      }
      node.expanded = true;
    },
   // 设置
    onSetting() {
      this.settingVisible = true;
    },
    closeTooltip() {
      this.$refs.buildFloor.onscroll = () => {
        document.querySelectorAll('.el-tooltip__popper').forEach(function(el) {
          el.style.display = 'none';
        });
      }
    }
  },
};
</script>

<style lang="stylus" scoped>

.img-type
  padding 10px 10px 0 10px

.setup
  text-align right
  padding 0 10px
  margin-bottom: 10px

.treeBox
  height calc(100vh - 220px)
  overflow auto

>>> .el-tree-node__expand-icon
  display block
  position relative
  left -500px
>>> .el-tree-node__content
  width 100%
  box-sizing border-box

.sheet-tree
  position reletive

.my-custom
  width 100%
  display inline-block
  padding-right 16px
  // user-select none
  position relative
  overflow hidden
  text-overflow ellipsis
.node-operate
  position absolute
  right 15px
  top 1px

.el-icon-star-on
  font-size 18.5px
  position relative
  top -1px
  color rgb(255,160,0)
.el-icon-star-off
  font-size 15px
  position relative
  top -2px
  color #999
.el-icon-s-tools
  font-size 18px
  color #1A936F

.input-filter
  width auto
  display block
  padding 10px
  >>> input
    height 32px

.icon {
  width: 18px;
  height: 18px;
  vertical-align: middle;
  overflow: hidden;
  position relative
  top -1px
}
.setup >>> .el-button {
  padding: 4px 8px;
  margin-left: 5px
}

>>> .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
    background-color: rgba(36,198,154,0.3);
}
</style>
